module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/UploadYourOwn-4617c34d914b401f1c836764d4895ae7.png";